module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Media1-b3feb2bf22c4a1c61296214f0868b34a.png";